import React from 'react';
import Header from './Header';
import myface from "./Photos/myface.JPEG";

export default function FirstPage() {

    return (
        <main>
     
            <section className="py-5 text-center container">
                <Header />
                <div className="row py-lg-5">
                    <div className="col-lg-8 col-md-10 mx-auto">
                        <h1 className="fw-light">Welcome!</h1>
                        <p className="lead text-muted">
                            This is the first page to my personal website. Feel free to click on any section
                            above in the header that you may be interested in.
                        </p>
                    </div>
                </div>
            </section>
            <div className="album py-3 bg-light">
                <div className="container text-center">
                    <h1 className="cover-heading fw-light" >Here’s a little about me</h1>
                    <p className="lead">
                        My name is Adi. I’m a Computer Science graduate currently working as a Data and Cloud
                        Engineer consultant at a large consulting firm. Based on Vancouver Island,
                        I love spending my days surrounded by the island’s natural beauty. 
                        Outside of work, I’m passionate about creating—whether it’s a
                        new art piece, a travel itinerary, a recipe, or a software project. 
                        This website is my space to share some of my personal work and the 
                        things that inspire me.
                    </p>

                    <img 
                        src={myface} 
                        alt="Portrait of me" 
                        className="myface-img"
                    />
                </div>
            </div>
        </main>
    );
}